import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Panel, Btn, Field, inputCls, SingleImageUploader } from "./AdminUI";
import { Plus, Pencil, Trash2 } from "lucide-react";

const empty = { name: "", post: "", phone: "", session_year: "2025–2026", photo: null, order: 99 };

export default function ManageExecutives() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(null);

  const load = () => api.get("/executives").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    const payload = { ...form, order: Number(form.order) || 99 };
    if (form.id) await api.put(`/executives/${form.id}`, payload);
    else await api.post("/executives", payload);
    setForm(null); load();
  };
  const del = async (id) => { if (window.confirm("Remove this office bearer?")) { await api.delete(`/executives/${id}`); load(); } };

  return (
    <Panel title="Manage Executive Body" actions={<Btn onClick={() => setForm({ ...empty })} data-testid="add-executive"><Plus size={15} /> Add Member</Btn>}>
      <p className="text-sm text-[#5A6270] mb-4">Add office bearers with their post, phone number and session year. Order controls display sequence.</p>
      {form && (
        <form onSubmit={save} className="mb-6 p-4 rounded-lg bg-[#FAF7F0] border border-[#E5DECF] space-y-3" data-testid="executive-form">
          <div className="grid sm:grid-cols-2 gap-3">
            <Field label="Name"><input className={inputCls} required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="exec-name" /></Field>
            <Field label="Post / Designation"><input className={inputCls} required placeholder="President / Secretary…" value={form.post} onChange={(e) => setForm({ ...form, post: e.target.value })} data-testid="exec-post" /></Field>
            <Field label="Phone Number"><input className={inputCls} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="exec-phone" /></Field>
            <Field label="Session Year"><input className={inputCls} value={form.session_year} onChange={(e) => setForm({ ...form, session_year: e.target.value })} data-testid="exec-session" /></Field>
            <Field label="Display Order"><input type="number" className={inputCls} value={form.order} onChange={(e) => setForm({ ...form, order: e.target.value })} /></Field>
          </div>
          <Field label="Photo (optional)"><SingleImageUploader path={form.photo} onChange={(p) => setForm({ ...form, photo: p })} label="Upload photo" /></Field>
          <div className="flex gap-2"><Btn type="submit" data-testid="exec-save">Save</Btn><Btn type="button" variant="outline" onClick={() => setForm(null)}>Cancel</Btn></div>
        </form>
      )}
      <div className="space-y-2">
        {list.map((x) => (
          <div key={x.id} className="flex items-center justify-between gap-3 border border-[#F0E9DA] rounded-lg px-4 py-3" data-testid={`admin-exec-${x.id}`}>
            <div><div className="font-medium text-[#2a2422]">{x.name}</div><div className="text-xs text-[#5A6270]">{x.post} · {x.phone || "no phone"} · {x.session_year}</div></div>
            <div className="flex gap-2">
              <Btn variant="outline" onClick={() => setForm(x)}><Pencil size={14} /></Btn>
              <Btn variant="danger" onClick={() => del(x.id)} data-testid={`delete-exec-${x.id}`}><Trash2 size={14} /></Btn>
            </div>
          </div>
        ))}
      </div>
    </Panel>
  );
}
